import React, { useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { useSocialProof } from '../hooks/useSocialProof';
export function SocialProofPopup() {
  const {
    isVisible,
    data
  } = useSocialProof();
  const [isDismissed, setIsDismissed] = useState(false);
  if (!isVisible || !data || isDismissed) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up sm:bottom-8 sm:left-8" data-id="element-206">
      <div className="relative flex items-center gap-4 rounded-lg border border-brand-green/20 bg-brand-black p-4 pr-10 shadow-2xl shadow-brand-green/10" data-id="element-207">
        <button onClick={() => setIsDismissed(true)} className="absolute right-2 top-2 text-gray-500 hover:text-white" aria-label="Cerrar notificación" data-id="element-208">
          <XIcon className="h-4 w-4" data-id="element-209" />
        </button>

        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-green/10" data-id="element-210">
          <CheckCircle2Icon className="h-6 w-6 text-brand-green" data-id="element-211" />
        </div>

        <div data-id="element-212">
          <p className="text-sm font-medium text-white" data-id="element-213">
            <span className="font-bold text-brand-green" data-id="element-214">{data.name}</span> de{' '}
            {data.city}
          </p>
          <p className="text-xs text-gray-400" data-id="element-215">
            Compró CIERRE 2.0 hace {data.timeAgo} min
          </p>
        </div>
      </div>
    </div>;
}